// eslint-disable-next-line max-classes-per-file
class RovingTabindexPopupMenuItem {
  constructor(domNode, menuObj, wrapper) {
    this.domNode = domNode;
    this.wrapper = wrapper;
    this.menu = menuObj;
    this.popupMenu = false;
    this.isMenubarItem = false;
    this.keyCode = Object.freeze({
      TAB: 9,
      RETURN: 13,
      ESC: 27,
      SPACE: 32,
      PAGEUP: 33,
      PAGEDOWN: 34,
      END: 35,
      HOME: 36,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40,
    });
  }

  init() {
    const submenu = this.wrapper.querySelector('[data-type="menu"]');
    this.domNode.tabIndex = -1;

    this.domNode.addEventListener('keydown', this.onKeyDown.bind(this));
    this.domNode.addEventListener('focus', this.onFocus.bind(this));
    this.domNode.addEventListener('blur', this.onBlur.bind(this));

    if (submenu) {
      // eslint-disable-next-line no-use-before-define
      this.popupMenu = new RovingTabindexPopupMenu(submenu, this);
      this.popupMenu.init();
    }
  }

  onKeyDown(event) {
    let resetEvents = false;

    switch (event.keyCode) {
      case this.keyCode.SPACE:
      case this.keyCode.RETURN:
        resetEvents = true;

        if (this.popupMenu) {
          this.popupMenu.open();
          this.popupMenu.setFocusToFirstItem();
        }

        break;
      case this.keyCode.UP:
        resetEvents = true;

        this.menu.setFocusToPreviousItem(this);

        break;

      case this.keyCode.DOWN:
        resetEvents = true;

        this.menu.setFocusToNextItem(this);

        break;

      case this.keyCode.LEFT:
        resetEvents = true;

        this.menu.setFocusToController('previous', true);
        this.menu.close(true);

        break;

      case this.keyCode.RIGHT:
        resetEvents = true;

        if (this.popupMenu) {
          this.popupMenu.open();
          this.popupMenu.setFocusToFirstItem();
        } else {
          this.menu.setFocusToController('next', true);
          this.menu.close(true);
        }

        break;

      case this.keyCode.HOME:
      case this.keyCode.PAGEUP:
        resetEvents = true;

        this.menu.setFocusToFirstItem();

        break;

      case this.keyCode.END:
      case this.keyCode.PAGEDOWN:
        resetEvents = true;

        this.menu.setFocusToLastItem();

        break;

      case this.keyCode.ESC:
        resetEvents = true;

        this.menu.setFocusToController();
        this.menu.close(true);

        break;

      case this.keyCode.TAB:
        this.menu.setFocusToController();
        break;

      default:
        break;
    }

    if (resetEvents) {
      this.resetEvents(event);
    }
  }

  onFocus() {
    this.menu.hasFocus = true;
  }

  onBlur() {
    this.menu.hasFocus = false;

    setTimeout(this.menu.close.bind(this.menu, false), 300);
  }

  resetEvents(event) {
    event.preventDefault();
  }
}

class RovingTabindexPopupMenu {
  constructor(domNode, controller) {
    this.isMenubar = false;
    this.domNode = domNode;
    this.controller = controller;
    this.menuitems = [];
    this.firstChars = [];
    this.firstItem = null;
    this.lastItem = null;
    this.hasFocus = false;
    this.hasHover = false;
  }

  init() {
    let popupMenuElement = this.domNode.firstElementChild;

    while (popupMenuElement) {
      const popupMenuItem = popupMenuElement.querySelector('[data-type="menuitem"]');

      if (popupMenuItem && popupMenuElement.tagName === 'LI') {
        const rovingTabindexPopupItem = new RovingTabindexPopupMenuItem(popupMenuItem, this, popupMenuElement);

        rovingTabindexPopupItem.init();
        this.menuitems.push(rovingTabindexPopupItem);
      }

      popupMenuElement = popupMenuElement.nextElementSibling;
    }

    if (this.menuitems.length > 0) {
      this.firstItem = this.menuitems[0];
      this.lastItem = this.menuitems[this.menuitems.length - 1];
    }
  }

  open() {
    this.domNode.ariaHidden = 'false';
    this.controller.domNode.ariaExpanded = 'true';
  }

  close(force) {
    let hasFocus = this.hasFocus;

    if (!hasFocus) {
      hasFocus = this.menuitems.some((item) => item.popupMenu.hasFocus);
    }

    if (force || !hasFocus) {
      this.domNode.ariaHidden = 'true';
      this.controller.domNode.ariaExpanded = 'false';
    }
  }

  setFocusToFirstItem() {
    this.firstItem.domNode.focus();
  }

  setFocusToLastItem() {
    this.lastItem.domNode.focus();
  }

  setFocusToPreviousItem(currentItem) {
    if (currentItem === this.firstItem) {
      this.lastItem.domNode.focus();
    } else {
      const index = this.menuitems.indexOf(currentItem);
      this.menuitems[index - 1].domNode.focus();
    }
  }

  setFocusToNextItem(currentItem) {
    if (currentItem === this.lastItem) {
      this.firstItem.domNode.focus();
    } else {
      const index = this.menuitems.indexOf(currentItem);
      this.menuitems[index + 1].domNode.focus();
    }
  }

  setFocusToController(command) {
    if (command === '') {
      if (this.controller && this.controller.domNode) {
        this.controller.domNode.focus();
      }

      return;
    }

    if (!this.controller.isMenubarItem) {
      this.controller.domNode.focus();
      this.close();

      if (command === 'next') {
        const menubarItem = this.setFocusToMenubarItem(this.controller, false);

        if (menubarItem) {
          menubarItem.menu.setFocusToNextItem(menubarItem);
        }
      }
    } else {
      if (command === 'previous') {
        this.controller.menu.setFocusToPreviousItem(this.controller);
      } else if (command === 'next') {
        this.controller.menu.setFocusToNextItem(this.controller);
      }
    }
  }

  setFocusToMenubarItem(controller, close) {
    while (controller) {
      if (controller.isMenubarItem) {
        controller.domNode.focus();

        return controller;
      }

      if (close) {
        controller.menu.close(true);
      }

      controller.hasFocus = false;
      controller = controller.menu.controller;
    }

    return false;
  }
}

class RovingTabindexMenuItem {
  constructor(domNode, menuObj, wrapper) {
    this.menu = menuObj;
    this.wrapper = wrapper;
    this.domNode = domNode;
    this.popupMenu = false;
    this.hasFocus = false;
    this.hasHover = false;
    this.isMenubarItem = true;
    this.keyCode = Object.freeze({
      TAB: 9,
      RETURN: 13,
      ESC: 27,
      SPACE: 32,
      PAGEUP: 33,
      PAGEDOWN: 34,
      END: 35,
      HOME: 36,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40,
    });
  }

  init() {
    const submenu = this.wrapper.querySelector('[data-type="menu"]');
    this.domNode.tabIndex = -1;

    this.domNode.addEventListener('keydown', this.onKeyDown.bind(this));
    this.domNode.addEventListener('focus', this.onFocus.bind(this));
    this.domNode.addEventListener('blur', this.onBlur.bind(this));

    if (submenu) {
      this.popupMenu = new RovingTabindexPopupMenu(submenu, this);

      this.popupMenu.init();
    }
  }

  onKeyDown(event) {
    let resetEvents = false;

    switch (event.keyCode) {
      case this.keyCode.SPACE:
      case this.keyCode.RETURN:
      case this.keyCode.DOWN:
        if (this.popupMenu) {
          resetEvents = true;

          this.popupMenu.open();
          this.popupMenu.setFocusToFirstItem();
        }

        break;

      case this.keyCode.LEFT:
        resetEvents = true;

        this.menu.setFocusToPreviousItem(this);

        break;

      case this.keyCode.RIGHT:
        resetEvents = true;

        this.menu.setFocusToNextItem(this);

        break;

      case this.keyCode.UP:
        if (this.popupMenu) {
          resetEvents = true;

          this.popupMenu.open();
          this.popupMenu.setFocusToLastItem();
        }

        break;

      case this.keyCode.HOME:
      case this.keyCode.PAGEUP:
        resetEvents = true;

        this.menu.setFocusToFirstItem();

        break;

      case this.keyCode.END:
      case this.keyCode.PAGEDOWN:
        resetEvents = true;

        this.menu.setFocusToLastItem();

        break;

      case this.keyCode.TAB:
        this.popupMenu.close(true);

        break;

      case this.keyCode.ESC:
        this.popupMenu.close(true);

        break;

      default:
        break;
    }

    if (resetEvents) {
      this.resetEvents(event);
    }
  }

  onFocus(event) {
    this.menu.hasFocus = true;
    // Remove default behavior and events
    this.resetEvents(event);
  }

  onBlur() {
    this.menu.hasFocus = false;
  }

  resetEvents(event, stop = false) {
    event.preventDefault();
    if (stop) {
      event.stopPropagation();
    }
  }
}

class RovingTabindexMenu {
  constructor(domNode) {
    if (domNode) {
      this.isMenubar = true;

      this.domNode = domNode;
      this.menubarItems = [];
      this.firstItem = null;
      this.lastItem = null;
      this.hasFocus = false;
      this.hasHover = false;
    }
  }

  init() {
    let menubarItem = this.domNode.firstElementChild;

    while (menubarItem) {
      const menuItem = menubarItem.querySelector('[data-type="menuitem"]');

      if (menubarItem && menuItem) {
        const rovingTabindexMenuItem = new RovingTabindexMenuItem(menuItem, this, menubarItem);

        rovingTabindexMenuItem.init();
        this.menubarItems.push(rovingTabindexMenuItem);
      }

      menubarItem = menubarItem.nextElementSibling;
    }

    if (this.menubarItems.length > 0) {
      this.firstItem = this.menubarItems[0];
      this.lastItem = this.menubarItems[this.menubarItems.length - 1];
    }

    this.firstItem.domNode.tabIndex = 0;
  }

  setFocusToItem(newItem) {
    let flag = false;

    for (let i = 0; i < this.menubarItems.length; i++) {
      let item = this.menubarItems[i];

      if (item.domNode.tabIndex === 0 || item.domNode.tabIndex === '0') {
        flag = item.domNode.getAttribute('aria-expanded') === 'true';
      }

      item.domNode.tabIndex = '-1';

      if (item.popupMenu) {
        item.popupMenu.close();
      }
    }

    newItem.domNode.focus();
    newItem.domNode.tabIndex = '0';

    if (flag && newItem.popupMenu) {
      newItem.popupMenu.open();
    }
  }

  setFocusToFirstItem() {
    this.setFocusToItem(this.firstItem);
  }

  setFocusToLastItem() {
    this.setFocusToItem(this.lastItem);
  }

  setFocusToPreviousItem(currentItem) {
    let newItem = null;

    if (currentItem === this.firstItem) {
      newItem = this.lastItem;
    } else {
      const index = this.menubarItems.indexOf(currentItem);
      newItem = this.menubarItems[index - 1];
    }

    this.setFocusToItem(newItem);
  }

  setFocusToNextItem(currentItem) {
    let newItem = null;

    if (currentItem === this.lastItem) {
      newItem = this.firstItem;
    } else {
      const index = this.menubarItems.indexOf(currentItem);
      newItem = this.menubarItems[index + 1];
    }

    this.setFocusToItem(newItem);
  }
}

function robingTabindexVerticalToggleMenu(toggleMenu) {
  if (toggleMenu) {
    toggleMenu.children.forEach((toggleMenuItem, toggleIndex) => {
      const menuToggler = toggleMenuItem.querySelector('[data-type="menuitem"]');
      const menu = toggleMenuItem.querySelector('[data-type="menu"]');

      menuToggler.addEventListener('focus', () => {
        if (menu) {
          const firstMenuItem = menu.children[0].querySelector('[data-type="menuitem"]');
          const lastMenuItem = menu.children[menu.children.length - 1].querySelector('[data-type="menuitem"]');

          menu.children.forEach((item, menuIndex) => {
            const menuItem = item.querySelector('[data-type="menuitem"]');
            menuItem.tabIndex = '-1';

            menuItem.addEventListener('keydown', (event) => {
              let resetEvents = false;

              switch (event.key) {
                case 'ArrowDown':
                  resetEvents = true;

                  if (menuItem === lastMenuItem) {
                    firstMenuItem.focus();
                  } else {
                    const newMenuItem = menu.children[menuIndex + 1].querySelector('[data-type="menuitem"]');

                    newMenuItem.focus();
                  }

                  break;

                case 'ArrowUp':
                  resetEvents = true;

                  if (menuItem === firstMenuItem) {
                    lastMenuItem.focus();
                  } else {
                    const newMenuItem = menu.children[menuIndex - 1].querySelector('[data-type="menuitem"]');

                    newMenuItem.focus();
                  }

                  break;

                case 'Tab': {
                  let newToggle = toggleMenu.children[toggleIndex + 1];

                  if (newToggle) {
                    resetEvents = true;
                    const newTogglerItem = newToggle.querySelector('[data-type="menuitem"]');

                    setTimeout(() => {
                      newTogglerItem.focus();
                    }, 300);
                  }

                  break;
                }

                default:
                  break;
              }

              if (resetEvents) {
                event.preventDefault();
              }
            });
          });
        }
      });

      menuToggler.addEventListener('keydown', (event) => {
        if (event.key === ' ' && menu) {
          const firstMenuItem = menu.children[0].querySelector('[data-type="menuitem"]');

          setTimeout(() => {
            firstMenuItem.focus();
          }, 300);
        }
      });
    });
  }
}

function handlePLPFilterDrawerOnClose(event, openDrawerButton, drawer, handler) {
  if (event.key === 'Esc' || event.key === 'Escape') {
    drawer.ariaHidden = 'true';

    setTimeout(() => {
      openDrawerButton.focus();
    }, 300);
    document.removeEventListener('keydown', handler);
  }
}

function handlePLPFilterDrawer() {
  const openDrawerButton = document.querySelector('[aria-controls="mobile-collection-filters"][data-action="open-drawer"]');
  const drawer = document.getElementById('mobile-collection-filters');
  const closeHandler = (event) => handlePLPFilterDrawerOnClose(event, openDrawerButton, drawer, closeHandler);

  if (openDrawerButton && drawer) {
    const closeButton = drawer.querySelector('[data-action="close-drawer"]');

    openDrawerButton.addEventListener('click', () => {
      document.addEventListener('keydown', closeHandler);
      setTimeout(() => {
        closeButton.focus();
      }, 300);
    });

    closeButton.addEventListener('click', () => {
      setTimeout(() => {
        openDrawerButton.focus();
      }, 300);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const links = document.links;
  const menubar = new RovingTabindexMenu(document.getElementById('desktop-menubar'));

  menubar.init();
  handlePLPFilterDrawer();
  robingTabindexVerticalToggleMenu(document.getElementById('collection-filters'));

  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].setAttribute('aria-label', 'Opens in a new window');
    }
  }
});
